import React from "react";
import { Grid, Typography, TextField, Autocomplete, Box, useTheme } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useTranslation } from "react-i18next";
import GenericDatePicker from "../../components/GenericDatePicker/GenericDatePicker";
import BreakdownDescription from "./BreakdownDescription";

const RecordOfIntervention = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    return (
        <Grid container xs={12} sm={6} md={6}>
            <Box
                sx={{
                    width: "98%",
                    px: 1,
                    py: 1,
                    m: 1,
                    mt: 0,
                    alignItems: "center",
                    backgroundColor: theme.palette.grey[100],
                    borderRadius: "12px",
                    boxShadow: 3,
                    gap: 2
                }}
            >
                <Grid item xs={12} sm={12} md={12}>
                    <Typography variant="h6" align="center" sx={{ fontSize: 15, backgroundColor: "#DEE0E0" }}>
                        {t("RecordOfIntervention")}
                    </Typography>
                    {/* RECORD OF INTERVENTION */}

                    <Grid container xs={12} sm={12}>
                        <Grid item xs={4} sm={4} padding={1}>
                            <LocalizationProvider id="bl_table_LocalizationProvider _2" dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    id="bl_table_DatePicker _13"
                                    renderInput={(_props) => <TextField {..._props} size="small" />}
                                    inputFormat="dd.MM.yyyy HH:mm"
                                    value={props.taskCreatedDate}
                                    label={t("TimeBreakdownOccured")}
                                    ampm={false}
                                    onChange={props.onTaskCreatedDateChange}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={4} sm={4} padding={1}>
                            <TextField
                                label={t("Wait(min)")}
                                size="small"
                                type="number"
                                disabled={props.disableStates.isWaitDisable}
                                value={props.waitMin}
                                onChange={props.handleWaitMinChange}
                                fullWidth
                                error={props.hasWaitMinError}
                                helperText={props.waitMinErrorText}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            ></TextField>
                        </Grid>
                        <Grid item xs={4} sm={4} padding={1}>
                            <TextField
                                label={t("Diagnosis")}
                                size="small"
                                type="number"
                                disabled={props.disableStates.isDiagnosisDisable}
                                value={props.diagnosisMin}
                                onChange={props.handleDiagnosisMinChange}
                                fullWidth
                                error={props.hasDiagnosisMinError}
                                helperText={props.diagnosisMinErrorText}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            ></TextField>
                        </Grid>
                        <Grid item xs={4} sm={4} padding={1}>
                            <TextField
                                label={t("SparePartSearch(min)")}
                                size="small"
                                type="number"
                                disabled={props.disableStates.isSpSearchDisable}
                                value={props.spSearchMin}
                                onChange={props.handleSpSearchMinChange}
                                fullWidth
                                error={props.hasSpSearchMinError}
                                helperText={props.spSearchMinErrorText}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            ></TextField>
                        </Grid>
                        <Grid item xs={4} sm={4} padding={1}>
                            <TextField
                                label={t("Repairing(min)")}
                                size="small"
                                type="number"
                                disabled={props.disableStates.isRepairingDisable}
                                value={props.repairingMin}
                                onChange={props.handleRepairingMinChange}
                                fullWidth
                                error={props.hasRepairingMinError}
                                helperText={props.repairingMinErrorText}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                inputProps={{ min: 0 }}
                            ></TextField>
                        </Grid>
                        <Grid item xs={4} sm={4} padding={1}>
                            <TextField
                                label={t("StartUp(min)")}
                                size="small"
                                type="number"
                                disabled={props.disableStates.isStartupDisable}
                                value={props.startUpMin}
                                onChange={props.handleStartUpMinChange}
                                fullWidth
                                error={props.hasStartUpMinError}
                                helperText={props.startUpMinErrorText}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            ></TextField>
                        </Grid>
                        <Grid item xs={4} sm={4} padding={1}>
                            <LocalizationProvider id="bl_table_LocalizationProvider _2" dateAdapter={AdapterDateFns}>
                                <GenericDatePicker
                                    id="upmotr_table_DatePicker_12"
                                    dateValue={props.interventionEndedDate}
                                    minDateTime={props.taskCreatedDate}
                                    label={t("InterventionEndedDate")}
                                    size="small"
                                    disabled
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid xs={2} sm={2} padding={1} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Typography variant="h6" sx={{ fontSize: 15 }}>
                                {t("Type")}:
                            </Typography>
                        </Grid>
                        <Grid xs={6} sm={6} padding={1}>
                            <Autocomplete
                                id="rb_breakdownReasonGroup_autocomplete"
                                style={{ marginTop: -15 }}
                                options={props.breakdownGroupData.map((option) => option.breakdownReasonGroupLocalizationName ?? option.name)}
                                onChange={(_event, newValue) => {
                                    props.handleBreakdownGroupChange(newValue);
                                }}
                                value={props.breakdownReasonGroupName || null}
                                renderInput={(params) => (
                                    <TextField
                                        id="rb_textField_6"
                                        {...params}
                                        margin="normal"
                                        label={t("BreakdownGroup")}
                                        variant="outlined"
                                        error={props.hasBreakdownGroupError}
                                        helperText={props.breakdownGroupErrorText}
                                    />
                                )}
                                size="small"
                                fullWidth
                                disabled={props.disableStates.isBreakdownGroupDisable}
                            />
                        </Grid>
                    </Grid>
                    {/* BREAKDOWN DESCRIPTION(TEXT & SKETCHES) */}
                    <BreakdownDescription images={props.images} onChange={props.onChange} fromPage={props.fromPage} handleRemoveAll={props.handleRemoveAll} />
                </Grid>
            </Box>
        </Grid>
    );
};

export default RecordOfIntervention;
